import { render, staticRenderFns } from "./OurReviews.vue?vue&type=template&id=166668b8&"
import script from "./OurReviews.vue?vue&type=script&lang=js&"
export * from "./OurReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports